{
    "mulakatdegerlendirme": {
        "Baslik": "Interview Evaluatie",
        "AdSoyad": "Volledige Naam",
        "Telefon": "Telefoon",
        "Email": "E-mail",
        "Gorusme": "Gesprek",
        "Not": "Notitie",
        "KisiBilgisi": "Persoonlijke Informatie",
        "Iletisim": "Communicatie",
        "Muhakeme": "Redeneren",
        "CalismaAliskanliklari": "Werkgewoonten",
        "Degerlendirme": "Evaluatie",
        "DegerlendirmeSonucu": "Evaluatieresultaat",
        "GenelDegerlendirme": "Algemene Evaluatie en Visies",
        "Soru": "Vraag",
        "Yanit": "Antwoord",
        "Puan": "Score",
        "IfadeEtme": "Zelfexpressie",
        "SoruSormaDinleme": "Effectief Vragen Stellen en Luisteren",
        "Etkileme": "Invloed",
        "NegatifGostergeler": "Negatieve Indicatoren",
        "PozitifGostergeler": "Positieve Indicatoren",
        "AdayKayıtEt": "Kandidaat Registreren",
        "Gorusme1": "1e Gesprek",
        "Gorusme2": "2e Gesprek",
        "IletisimAciklama": "GEEVALUEERDE COMPETENTIE: Interpersoonlijke communicatie (Expressie, actief luisteren, effectief vragen stellen, samenvatten)",
        "MuhakemeAciklama": "GEEVALUEERDE COMPETENTIE: Redeneren (Analyse en besluitvorming)",
        "CalismaAciklama": "WERKGEWOONTEN (Bewustzijn van verantwoordelijkheden, tijdige voltooiing van taken, vlijtigheid)",
        "SoruKai1": "Leg een ervaring uit waarbij u met succes de mening van iemand hebt veranderd en hen in uw richting hebt geleid.",
        "SoruKai2": "Leg aan de hand van een voorbeeld uit welke methoden u gebruikt om effectief naar iemand te luisteren.",
        "SoruMuka1": "Leg uit hoe u hebt geprobeerd een probleem op te lossen dat verband houdt met uw werk en dat u aanzienlijk heeft uitgedaagd.",
        "SoruMuka2": "Leg een ervaring uit waarbij u de visies en behoeften van mensen om u heen nauwkeurig hebt geïdentificeerd.",
        "SoruCal1": "Leg een ervaring uit waarbij u eigenaarschap nam over een taak en deze met succes op tijd en volledig hebt voltooid.",
        "SoruCal2": "Vertel over een geval waarbij u uw taken niet op tijd kon afronden.",
        "YanitPlaceholder": "Uw antwoord",
        "PuanAraligi": "Score (1-10)",
        "NegatifIndicator1": "Verzonden berichten zijn niet duidelijk en begrijpelijk",
        "NegatifIndicator1_2": "Luisteraars vervelen door onnodige en lange toespraken te houden",
        "PositiveIndicator1": "Drukt gedachten duidelijk en correct uit, vloeiende spraak",
        "PositiveIndicator1_2": "Gebruik van passende lichaamstaal en stemtoon",
        "NegatifIndicator2": "Afwijken van focus door niet te luisteren",
        "NegatifIndicator2_2": "Niet luisteren door te focussen op wat ze gaan zeggen",
        "PositiveIndicator2": "Luisteren naar anderen, rekening houden met hun gedachten",
        "PositiveIndicator2_2": "Actief luisteren tonen (bevestigen, knikken, samenvatten)",
        "NegatifIndicator3": "Niet in staat zijn alternatieve methoden te vinden bij tegengestelde ideeën",
        "NegatifIndicator3_2": "Zich terugtrekken en niet proberen te overtuigen bij tegengestelde ideeën",
        "PositiveIndicator3": "Gematigd en verzoenend zijn, positieve benadering van gebeurtenissen",
        "PositiveIndicator3_2": "Verdedigt met succes eigen idee door sterke redenen aan te voeren tegenover tegengestelde ideeën",
        "NegatifIndicatorMuka": "Relaties tussen gebeurtenissen niet kunnen zien",
        "NegatifIndicatorMuka2": "Beslissingen nemen met een zware emotionele kant, gebrek aan rationele basis",
        "PositiveIndicatorMuka": "Systematische benadering van situatie, gebeurtenis en informatie",
        "PositiveIndicatorMuka2": "Oordelen bereiken op basis van logica en feiten",
        "NegatifIndicatorCal": "Zelfopoffering vermijden, de taak niet toe-eigenen",
        "NegatifIndicatorCal2": "Anderen de schuld geven van fouten",
        "PositiveIndicatorCal": "Werkplezier en doorzettingsvermogen hebben",
        "PositiveIndicatorCal2": "Zichzelf zien als eigenaar van de taak, op tijd voltooid"
    },
    "Onceki": "Vorige",
    "Sonraki": "Volgende",
    "Kaydet": "Opslaan",
    "Guncelle": "Bijwerken",
    "Seciniz": "Selecteer",
    "Olumlu": "Positief",
    "Olumsuz": "Negatief",
    "Arama": "Zoeken",
    "Kapat": "Sluiten",
    "Temizle": "Wissen",
    "Yenile": "Vernieuwen",
    "YeniEkle": "Nieuwe Toevoegen"
}
